import * as types from "./types";
import { combineReducers } from "redux";

function colegioSeleccionado(state = null, { type, payload }) {
  return type === types.COLEGIO_SELECCIONADO
    ? payload
    : type === types.RESET_COLEGIO_SELECCIONADO
      ? null
      : state;
}

function detalleColegio(state = null, { type, payload }) {
  return type === types.DETALLE_COLEGIO
    ? payload
    : type === types.RESET_DETALLE_COLEGIO
      ? null
      : state;
}

function listaResguardos(state = [], { type, payload }) {
  return type === types.LISTA_RESGUARDOS
    ? payload
    : type === types.RESET_LISTA_RESGUARDOS
      ? []
      : state;
}

function procesoEnvio(state = 0, { type, payload }) {
  return type === types.PROCESO_ENVIO
    ? payload
    : type === types.RESET_PROCESO_ENVIO
      ? 0
      : state;
}

function uploadComplete(state = "", { type, payload }) {
  return type === types.UPLOAD_COMPLETE
    ? payload
    : type === types.CLEAR_UPLOAD_COMPLETE
      ? ""
      : state;
}

const reducer = combineReducers({
  colegioSeleccionado,
  detalleColegio,
  listaResguardos,
  procesoEnvio,
  uploadComplete
});

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/documentacion/reducers.js